import { useEffect, useMemo } from "react";
import { Config } from "src/Utils/ConfigService/LoadConfig";
import { useGetRequest } from "../ApiWrappers/useGetRequest";

export interface ICountry {
    id: number;
    name: string;
    supported: boolean;
    businessRuleViolations: string[];
    domainEvents: any[];
    isValid: boolean;
}

export const useGetClinicCountries = () => {
    const baseUrl = useMemo(() => Config.GetConfigData().serviceUrl, []);
    const scope = Config.GetConfigData().auraWebService?.scopes[0];
    const requestUrl = `${baseUrl}api/v1/country`;
    const [getDetails, countries, loading, error] = useGetRequest<ICountry[]>();

    useEffect(() => {
        getDetails(scope, requestUrl);
    }, [getDetails, requestUrl, scope]);

    return { 
        countries: countries || [], 
        loading, 
        error 
    };
};